export default {
    name: 'sponsors-footer'
};



// WEBPACK FOOTER //
// ./src/components/shared/layout/sponsors-footer/sponsors-footer.js